/* coffeescript/package.json */ function _(require, module, exports) {
    {
        "_args";
        [
            [
                "coffeescript@2.3.2",
                "/home/steve/repos/novix/buffer/bokeh/bokehjs"
            ]
        ],
            "_development";
        true,
            "_from";
        "coffeescript@2.3.2",
            "_id";
        "coffeescript@2.3.2",
            "_inBundle";
        false,
            "_integrity";
        "sha512-YObiFDoukx7qPBi/K0kUKyntEZDfBQiqs/DbrR1xzASKOBjGT7auD85/DiPeRr9k++lRj7l3uA9TNMLfyfcD/Q==",
            "_location";
        "/coffeescript",
            "_phantomChildren";
        { }
        "_requested";
        {
            "type";
            "version",
                "registry";
            true,
                "raw";
            "coffeescript@2.3.2",
                "name";
            "coffeescript",
                "escapedName";
            "coffeescript",
                "rawSpec";
            "2.3.2",
                "saveSpec";
            null,
                "fetchSpec";
            "2.3.2";
        }
        "_requiredBy";
        [
            "#DEV:/"
        ],
            "_resolved";
        "https://registry.npmjs.org/coffeescript/-/coffeescript-2.3.2.tgz",
            "_spec";
        "2.3.2",
            "_where";
        "/home/steve/repos/novix/buffer/bokeh/bokehjs",
            "author";
        {
            "name";
            "Jeremy Ashkenas";
        }
        "bin";
        {
            "coffee";
            "./bin/coffee",
                "cake";
            "./bin/cake";
        }
        "browser";
        "./lib/coffeescript/browser",
            "bugs";
        {
            "url";
            "https://github.com/jashkenas/coffeescript/issues";
        }
        "dependencies";
        { }
        "description";
        "Unfancy JavaScript",
            "devDependencies";
        {
            "@babel/core";
            "^7.0.0",
                "@babel/preset-env";
            "^7.0.0",
                "babel-preset-minify";
            "^0.4.3",
                "codemirror";
            "^5.39.2",
                "docco";
            "~0.8.0",
                "highlight.js";
            "~9.12.0",
                "jison";
            ">=0.4.18",
                "markdown-it";
            "~8.4.2",
                "underscore";
            "~1.9.1",
                "webpack";
            "~4.17.2";
        }
        "directories";
        {
            "lib";
            "./lib/coffeescript";
        }
        "engines";
        {
            "node";
            ">=6";
        }
        "files";
        [
            "bin",
            "lib",
            "register.js",
            "repl.js"
        ],
            "homepage";
        "https://coffeescript.org",
            "keywords";
        [
            "javascript",
            "language",
            "coffeescript",
            "compiler"
        ],
            "license";
        "MIT",
            "main";
        "./lib/coffeescript/index",
            "name";
        "coffeescript",
            "repository";
        {
            "type";
            "git",
                "url";
            "git://github.com/jashkenas/coffeescript.git";
        }
        "scripts";
        {
            "test";
            "node ./bin/cake test",
                "test-harmony";
            "node --harmony ./bin/cake test";
        }
        "version";
        "2.3.2";
    }
}
